// base environment shared by all apps
// each app specifies its own environment.base.ts that is based off this file

// AltoAzureTablesUrl, EmbedAzureTablesUrl:
//  values are also stored in Web.config and StorageProvider.cs so update there also if changing here.

import { RawClientConfiguration } from "./adapt-client-configuration";

export const clientConfiguration: Partial<RawClientConfiguration> = {
    AdaptEnvironmentName: "Local",
    AltoApiBaseUri: "http://localhost:4300",
    AltoAzureTablesUrl: "https://adaptdev2.table.core.windows.net/",
    AltoBaseUri: "http://localhost:4305",
    AnalyticsProductId: "",
    ApiBaseUri: "/api",
    BoxClientId: "l4ljnh88sav6vg083t1nx6seu1vdpwnr",
    DeepDiveDomain: "https://adaptdeepdivestaging.z26.web.core.windows.net",
    DropboxAppKey: "kqq9nh24c7i0xp1",
    EmbedApiBaseUri: "/api",
    EmbedAzureTablesUrl: "https://adaptdev2.table.core.windows.net",
    EmbedBaseUri: "http://localhost:4301",
    FroalaKey: "YNB3fH3C8A6A5B4E3F3C-8TMIBDIa1NTMNZFFPFZc1d1Ib2a1E1fA4A3G3F3F2C6D5C4C3D2==",
    GoogleApiKey: "AIzaSyDkD9k7-4i56CZfwZRUSY0chEYPURr5Kvw",
    GoogleClientId: "799098505879-p5uciuk6kges86pnnhil2rg84d31ee8e.apps.googleusercontent.com",
    IntercomAppId: "q32mupku",
    MicrosoftClientId: "4bdd55c9-a959-42c8-b866-174d1b46dcf3",
    OneDriveClientId: "8f51d602-b047-427a-bcdc-f802ff020035",
    SentryTraceLevelName: "Error",
    ServiceApiBaseUri: "http://localhost:4303",
    StripePublicKey: "pk_test_1FhAZMakNbB63zYwUjAgFfiv",
    ToasterTraceLevelName: "Warning",
    TraceLevelName: "Debug",
    TrustedVimeoDomain: "http://player.vimeo.com/video/*",
    DxLicenseKey: "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjFjOTZlNDc3LWM2ZDItMTFlNC04MGM0LTAwMjU5MGQ5ZDVmZiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.n3RT5o3rVdRIPC+yBG/b2mRc57i9epgyu8CIKaNFjGacbxml5DBwVh9RiSkP3G4esILZtxGZOopsOKY0zCAUnPgPHsL/aG9GMfZK2pEKFH2P8JMAOHAqv9+QX166a0XNB8iDrg==",
};
